import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    customer : {}
}

const customerSlice = createSlice({
    name: "customer",
    initialState,
    reducers: {
        setStep: (state, { payload }) => {
            state.step = payload
        },
        clearValue: () => initialState,
    }
});

export const { setStep} = customerSlice.actions
export default customerSlice.reducer;